const BRAND_KEY_COLOR = "#1D5AA6";
const brandRamp = {
  10: "#00072C",
  20: "#00114B",
  30: "#001D65",
  40: "#002B73",
  50: "#00367F",
  60: "#00428C",
  70: "#0E4E99",
  80: "#1D5AA6",
  90: "#2C68B6",
  100: "#4078C2",
  110: "#5F8ECD",
  120: "#7DA4D8",
  130: "#98B7E1",
  140: "#B2C9E9",
  150: "#CCDCF2",
  160: "#E0F0FF"
};
const accent = {
  /** Fill for badges and indicators (use `onFill` for text on it). */
  fill: "#E07B24",
  /** Text and icons of the accent on white (light theme). */
  foregroundOnLight: "#9A4A06",
  /** Text and icons of the accent on dark surfaces (dark theme). */
  foregroundOnDark: "#F5A55C",
  /** Text on the accent fill. */
  onFill: "#1A1109",
  /** Subtle tinted background. */
  tintLight: "#FDEBDB",
  tintDark: "#3D2209"
};
const neutral = {
  /** "Encre": titles, body text and the "Bati" of the wordmark (15.39:1 on white). */
  ink: "#0B2545",
  /** "Béton clair": the warm page and panel background. */
  betonClair: "#F4F2EE",
  /** "Béton": borders, dividers, inactive icons (3.63:1 on white, not for text). */
  beton: "#8A867E",
  /** "Béton foncé": secondary text and control borders (6.86:1 on white). */
  betonFonce: "#5E5A53"
};
const atelier = {
  /** "Papier": subtle surfaces (table headers, nested panes, totals). */
  papier: "#FBFAF7",
  /** Hover of rows and items on white and papier. */
  hover: "#F1EEE8",
  /** Pressed rows and items. */
  pressed: "#E9E5DE",
  /** Neutral track (segmented tabs, progress tracks, the empty-state arch). */
  track: "#EEEBE5",
  /** Dividers between rows and around sheets (decoration only). */
  divider: "#E7E3DC",
  /** Hairline inside papier areas. */
  dividerSubtle: "#F0EDE8",
  /** Outline of non-input controls (outline buttons, cards that look clickable). */
  stroke: "#D3CEC5",
  strokeHover: "#C4BFB5",
  /** Selected navigation item and informative tint (brand text keeps 5.9:1 on it). */
  selected: "#E8EFF8",
  selectedHover: "#DCE6F4"
};
const night = {
  canvas: "#0E1622",
  sheet: "#152131",
  selected: "#1F3350",
  selectedHover: "#26406A"
};
const statusPairs = {
  light: {
    success: { fg: "#1E6B3F", bg: "#E5F3EA" },
    warning: { fg: "#8A4B00", bg: "#FDF0D5" },
    danger: { fg: "#B42318", bg: "#FCEBE9" },
    informative: { fg: "#1D5AA6", bg: "#E8F0FA" },
    neutral: { fg: "#4D4A44", bg: "#EEEBE5" }
  },
  dark: {
    success: { fg: "#8FD4A8", bg: "#163A27" },
    warning: { fg: "#F2C27A", bg: "#3A2A0D" },
    danger: { fg: "#F2A39B", bg: "#43191A" },
    informative: { fg: "#98B7E1", bg: "#1F3350" },
    neutral: { fg: "#C4CBD5", bg: "#223047" }
  }
};
const chartSeries = {
  light: ["#1D5AA6", "#1F7A8C"],
  dark: ["#7DA4D8", "#5FB7C7"]
};
const logoOnDark = {
  tile: "#2C68B6",
  flow: "#F5A55C",
  word: "#98B7E1"
};
export {
  BRAND_KEY_COLOR,
  accent,
  atelier,
  brandRamp,
  chartSeries,
  logoOnDark,
  neutral,
  night,
  statusPairs
};
//# sourceMappingURL=brand.js.map